import React from 'react'

import { sanitizeHtmlValue } from '@/lib/element-schema-sanitizers'
import { cn } from '@/lib/utils'
import { useBranding } from '@/hooks/use-branding'
import useLocale from '@/hooks/use-locale'

import ButtonRegister from '../button-register'

interface ContactSectionProps {
  className?: string
}

function ContactSection({ className }: ContactSectionProps) {
  const { text, lang } = useLocale()
  const { isFsdsDomain, siteName } = useBranding()
  const heading = isFsdsDomain
    ? text.MAIN.BODY.HEADING_9
    : lang === 'vi'
      ? `Bắt đầu học cùng ${siteName} ngay hôm nay`
      : `Start learning with ${siteName} today`

  return (
    <section className={cn('mt-16 sm:mt-20 md:mt-32', className)}>
      <div className="container">
        <div className="flex flex-col justify-center items-center bg-primary rounded-xl py-20">
          <div className="mb-10 max-w-[45rem]">
            <h2
              className="text-3xl font-semibold md:text-4xl lg:text-5xl text-center text-primary-foreground"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlValue(heading),
              }}
            />
          </div>
          <ButtonRegister className="bg-background text-foreground hover:bg-muted" />
        </div>
      </div>
    </section>
  )
}

export default ContactSection
